import memoize from "memoize-one";

import { IFontWeightName } from "../theme/fonts";
import { IScreenDimensions, IScreenSizes } from "../theme/sizes";
import { isMobile } from "./utils";

const MIN_CLICKABLE_ZONE = 32;

interface FontSizeParams {
  sizes: IScreenSizes;
  dimensions: IScreenDimensions;
}

const getFontSize = memoize(({ sizes, dimensions }: FontSizeParams): number => {
  if (sizes.desktop) {
    return dimensions.desktop;
  }
  if (sizes.tablet) {
    return dimensions.tablet;
  }
  return dimensions.mobile;
});

const fontWeightFromName = memoize((name: IFontWeightName): any => {
  let weight = 400;

  if (name === "heavy") {
    weight = 900;
  }
  if (name === "bold") {
    weight = 700;
  }
  if (name === "medium") {
    weight = 500;
  }
  if (name === "light") {
    weight = 300;
  }

  return isMobile.any() ? `${weight}` : weight;
});

const fontNameFromWeight = memoize((weight: number): IFontWeightName => {
  switch (weight) {
    case 900:
      return "heavy";
    case 700:
      return "bold";
    case 500:
      return "medium";
    case 400:
      return "regular";
    case 300:
    default:
      return "light";
  }
});

export type { FontSizeParams };
export {
  fontNameFromWeight,
  fontWeightFromName,
  getFontSize,
  MIN_CLICKABLE_ZONE,
};
